import React from "react";
import ButtonV2 from ".";
import { cn } from "../../../../../src/lib/utils";
import { ArrowUpRight } from "lucide-react";

export interface NavigateButtonProps {
  label: string;
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
  className?: string;
  icon?: React.ReactNode;
}

export const NavigateButton: React.FC<NavigateButtonProps> = ({
  label,
  onClick,
  disabled,
  loading,
  className,
  icon,
}) => {
  return (
    <ButtonV2
      variant="outline"
      size="md"
      onClick={onClick}
      disabled={disabled}
      loading={loading}
      suffix={icon ?? <ArrowUpRight size={16} strokeWidth={2} />}
      className={cn(
        "rounded-[8px]",
        "border border-[#3551F3]",
        "bg-[#EBEEFE]",
        "text-[#3551F3]",
        
        "shadow-[0px_1px_2px_rgba(0,0,0,0.05)]",

        "hover:bg-gradient-to-b hover:from-indigo-100/50 hover:to-indigo-100/50 hover:text-[#3551F3] hover:border-indigo-700",

        "focus-visible:ring-[3px] focus-visible:ring-[#C7D2FE] focus-visible:ring-offset-0 focus-visible:outline-none",
        "active:opacity-60",
        "transition-colors duration-150",

        className
      )}
    >
      {label}
    </ButtonV2>
  );
};